import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="relative py-16 md:py-24">
      <div className="container-site">
        <div className="reveal mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-primary-400">
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            关于一起看，你可能想知道的
          </h2>
        </div>

        <div className="reveal mx-auto mt-12 max-w-3xl space-y-3">
          {faqs.map((f, idx) => {
            const open = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open
                    ? 'border-primary-400/50 bg-background-100/70'
                    : 'border-background-200/70 bg-background-100/50'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      {open ? '–' : '+'}
                    </span>
                    {f.q}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}